import type { NUploader } from '../interface';

export function fileToObject(file: NUploader.IFileType | null): NUploader.IInternalUploadFile | null {
  if (!file) return null;

  return {
    ...file,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  };
}

export function updateFileList(file: NUploader.IUploadFile, fileList: NUploader.IUploadFile[]) {
  const nextFileList = [...fileList];
  const fileIndex = nextFileList.findIndex(({ uid }) => uid === file.uid);

  if (fileIndex === -1) {
    nextFileList.push(file);
  } else {
    nextFileList[fileIndex] = file;
  }

  return nextFileList;
}

export function getFileItem(file: NUploader.IFileType, fileList: NUploader.IUploadFile[]) {
  const matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter((item) => item[matchKey] === file[matchKey])[0];
}

export function removeFileItem(file: NUploader.IUploadFile, fileList: NUploader.IUploadFile[]) {
  const matchKey = file.uid !== undefined ? 'uid' : 'name';
  const removed = fileList.filter((item) => item[matchKey] !== file[matchKey]);

  if (removed.length === fileList.length) return null;
  return removed;
}
